var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col" }, [
    _c("div", [
      _c(
        "div",
        {
          staticClass:
            "align-middle inline-block w-full min-w-full shadow-lg sm:rounded-lg border-b border-gray-200",
        },
        [
          _c(
            "table",
            { staticClass: "w-full table-fixed" },
            [
              _c(
                "thead",
                [
                  _vm._t("header", function () {
                    return [
                      _c("table-header", {
                        attrs: { headers: _vm.headers, columns: _vm.columns },
                      }),
                    ]
                  }),
                ],
                2
              ),
              _vm._t("body"),
            ],
            2
          ),
          _vm._t("pagination"),
          _vm.pagination
            ? [
                _c("table-pagination", {
                  attrs: {
                    resultFrom: _vm.page * _vm.limit - _vm.limit + 1,
                    resultTo: _vm.page * _vm.limit,
                    total: _vm.total,
                  },
                  on: {
                    next: function ($event) {
                      return _vm.$emit("next")
                    },
                    prev: function ($event) {
                      return _vm.$emit("prev")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dropdown",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "ml-auto mr-3 max-w-sm" },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { id: "invitation-limit" },
                                    domProps: { value: _vm.limit },
                                    on: {
                                      input: (e) =>
                                        _vm.$emit(
                                          "updateLimit",
                                          e.target.value
                                        ),
                                    },
                                  },
                                  [
                                    _c("option", { domProps: { value: 5 } }, [
                                      _vm._v("5 per page"),
                                    ]),
                                    _c("option", { domProps: { value: 10 } }, [
                                      _vm._v("10 per page"),
                                    ]),
                                    _c("option", { domProps: { value: 25 } }, [
                                      _vm._v("25 per page"),
                                    ]),
                                    _c("option", { domProps: { value: 50 } }, [
                                      _vm._v("50 per page"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2184495387
                  ),
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }